"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Model/Chain
 */
var ChainOperationType;
(function (ChainOperationType) {
    ChainOperationType[ChainOperationType["transfer"] = 0] = "transfer";
    ChainOperationType[ChainOperationType["account_create"] = 1] = "account_create";
    ChainOperationType[ChainOperationType["account_update"] = 2] = "account_update";
    ChainOperationType[ChainOperationType["asset_create"] = 3] = "asset_create";
    ChainOperationType[ChainOperationType["asset_issue"] = 4] = "asset_issue";
    ChainOperationType[ChainOperationType["asset_publish_feed"] = 5] = "asset_publish_feed";
    ChainOperationType[ChainOperationType["miner_create"] = 6] = "miner_create";
    ChainOperationType[ChainOperationType["miner_update"] = 7] = "miner_update";
    ChainOperationType[ChainOperationType["miner_update_global_parameters"] = 8] = "miner_update_global_parameters";
    ChainOperationType[ChainOperationType["proposal_create"] = 9] = "proposal_create";
    ChainOperationType[ChainOperationType["proposal_update"] = 10] = "proposal_update";
    ChainOperationType[ChainOperationType["proposal_delete"] = 11] = "proposal_delete";
    ChainOperationType[ChainOperationType["withdraw_permission_create"] = 12] = "withdraw_permission_create";
    ChainOperationType[ChainOperationType["withdraw_permission_update"] = 13] = "withdraw_permission_update";
    ChainOperationType[ChainOperationType["withdraw_permission_claim"] = 14] = "withdraw_permission_claim";
    ChainOperationType[ChainOperationType["withdraw_permission_delete"] = 15] = "withdraw_permission_delete";
    ChainOperationType[ChainOperationType["vesting_balance_create"] = 16] = "vesting_balance_create";
    ChainOperationType[ChainOperationType["vesting_balance_withdraw"] = 17] = "vesting_balance_withdraw";
    ChainOperationType[ChainOperationType["custom"] = 18] = "custom";
    ChainOperationType[ChainOperationType["assert"] = 19] = "assert";
    ChainOperationType[ChainOperationType["content_submit"] = 20] = "content_submit";
    ChainOperationType[ChainOperationType["request_to_buy"] = 21] = "request_to_buy";
    ChainOperationType[ChainOperationType["leave_rating_and_comment"] = 22] = "leave_rating_and_comment";
    ChainOperationType[ChainOperationType["ready_to_publish"] = 23] = "ready_to_publish";
    ChainOperationType[ChainOperationType["proof_of_custody"] = 24] = "proof_of_custody";
    ChainOperationType[ChainOperationType["deliver_keys"] = 25] = "deliver_keys";
    ChainOperationType[ChainOperationType["subscribe"] = 26] = "subscribe";
    ChainOperationType[ChainOperationType["subscribe_by_author"] = 27] = "subscribe_by_author";
    ChainOperationType[ChainOperationType["automatic_renewal_of_subscription"] = 28] = "automatic_renewal_of_subscription";
    ChainOperationType[ChainOperationType["report_stats"] = 29] = "report_stats";
    ChainOperationType[ChainOperationType["set_publishing_manager"] = 30] = "set_publishing_manager";
    ChainOperationType[ChainOperationType["set_publishing_right"] = 31] = "set_publishing_right";
    ChainOperationType[ChainOperationType["content_cancellation"] = 32] = "content_cancellation";
    ChainOperationType[ChainOperationType["asset_fund_pools"] = 33] = "asset_fund_pools";
    ChainOperationType[ChainOperationType["asset_reserve"] = 34] = "asset_reserve";
    ChainOperationType[ChainOperationType["asset_claim_fees"] = 35] = "asset_claim_fees";
    ChainOperationType[ChainOperationType["update_user_issued_asset"] = 36] = "update_user_issued_asset";
    ChainOperationType[ChainOperationType["update_monitored_asset"] = 37] = "update_monitored_asset";
    ChainOperationType[ChainOperationType["ready_to_publish2"] = 38] = "ready_to_publish2";
    ChainOperationType[ChainOperationType["transfer2"] = 39] = "transfer2";
    ChainOperationType[ChainOperationType["update_user_issued_asset_precision_operation"] = 40] = "update_user_issued_asset_precision_operation";
    ChainOperationType[ChainOperationType["disallow_automatic_renewal_of_subscription"] = 41] = "disallow_automatic_renewal_of_subscription";
    ChainOperationType[ChainOperationType["return_escrow_submission"] = 42] = "return_escrow_submission";
    ChainOperationType[ChainOperationType["return_escrow_buying"] = 43] = "return_escrow_buying";
    ChainOperationType[ChainOperationType["pay_seeder"] = 44] = "pay_seeder";
    ChainOperationType[ChainOperationType["finish_buying"] = 45] = "finish_buying";
    ChainOperationType[ChainOperationType["renewal_of_subscription"] = 46] = "renewal_of_subscription";
})(ChainOperationType = exports.ChainOperationType || (exports.ChainOperationType = {}));
var ChainError;
(function (ChainError) {
    ChainError["command_execution_failed"] = "command_execution_failed";
    ChainError["api_connection_failed"] = "api_connection_failed";
})(ChainError = exports.ChainError || (exports.ChainError = {}));
var ChainMethodName;
(function (ChainMethodName) {
    ChainMethodName["getAccount"] = "getAccount";
    ChainMethodName["getAsset"] = "getAsset";
    ChainMethodName["getObject"] = "getObject";
})(ChainMethodName = exports.ChainMethodName || (exports.ChainMethodName = {}));
var Method = /** @class */ (function () {
    function Method(methodName, params) {
        this._name = methodName;
        this._parameters = params;
    }
    Object.defineProperty(Method.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Method.prototype, "parameters", {
        get: function () {
            return this._parameters;
        },
        enumerable: true,
        configurable: true
    });
    return Method;
}());
exports.Method = Method;
var ChainMethods;
(function (ChainMethods) {
    var GetAccount = /** @class */ (function (_super) {
        __extends(GetAccount, _super);
        function GetAccount(account) {
            return _super.call(this, ChainMethodName.getAccount, account) || this;
        }
        return GetAccount;
    }(Method));
    ChainMethods.GetAccount = GetAccount;
    var GetAsset = /** @class */ (function (_super) {
        __extends(GetAsset, _super);
        function GetAsset(assetId) {
            return _super.call(this, ChainMethodName.getAsset, assetId) || this;
        }
        return GetAsset;
    }(Method));
    ChainMethods.GetAsset = GetAsset;
})(ChainMethods = exports.ChainMethods || (exports.ChainMethods = {}));
//# sourceMappingURL=chain.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/api/model/chain.js
// module id = 25
// module chunks = 0